import {defineStore} from "pinia";
import {computed, Ref, ref} from "vue";
import defaults from "@src/stores/defaults";
import {IEmoji, ISettings, IUser} from "@src/types";
import {lastSyncHelper} from "@src/helpers/lastSyncHelper";
import ChatSession from "@src/types/ChatSession";
import axios from "axios";
import {db} from "@src/services/db";


type Status = "idle" | "loading" | "success" | "blocked";

const USER_KEY = "operatorv4:user";      // mesma chave do authStore
const CHAT_KEY = "chat";                 // seu storage atual


const useStore = defineStore("chat", () => {
    //app status refs
    const details = ref(false);
    const status = ref("idle")
    const getStatus = computed(() => status);
    const authError = ref("");
    const storage = JSON.parse(localStorage.getItem("chat") || "{}");
    const user: Ref<IUser | undefined> = ref();
    const settings: Ref<ISettings> = ref(
        storage.settings || defaults.defaultSettings
    );
    const recentEmoji: Ref<IEmoji[]> = ref(storage.recentEmoji || []);
    const emojiSkinTone: Ref<string> = ref(storage.emojiSkinTone || "neutral");

    //session data refs
    const archivedConversations: Ref<ChatSession[]> = ref([]);

    // ui refs
    const activeSidebarComponent: Ref<string> = ref('active');
    const delayLoading = ref(true);
    const conversationOpen: Ref<string | undefined> = ref(
        storage.conversationOpen
    );


    // actions/helpers
    const setAuthError = (msg: string) => (authError.value = msg);
    const clearAuthError = () => (authError.value = "");

    const setStatus = (value: Status) => (status.value = value);

    const setUser = (value: IUser | undefined) => (user.value = value);
    const clearUser = () => (user.value = undefined);

    // lastSync
    const setLastSync = (key: string, value: string) => lastSyncHelper.set(key, value);
    const getLastSync = (key: string, defaultValue: string | null = null) => lastSyncHelper.get(key, defaultValue);
    const clearLastSync = (key?: string) => lastSyncHelper.clear(key);


// TODO limpar sessoes e mensagens (task 2.2 no futuro)

    // const resetSession = () => {
    //     conversations.value = [];
    //     notifications.value = [];
    //     archivedConversations.value = [];
    //     conversationOpen.value = undefined;
    //
    //     clearLastSync();
    //
    //     clearUser();
    // };

// helper para ir para tela de login
    const goToLogin = async () => {
        setStatus("idle");
        clearAuthError();

        clearUser();

        localStorage.removeItem(USER_KEY);
        localStorage.removeItem(CHAT_KEY);
        lastSyncHelper.clear(); // limpa todos lastsync

        await Promise.all([
            db.sessions.clear(),
            db.messages.clear(),
            db.departments.clear(),
            db.channels.clear(),
            db.kanbans.clear(),
            db.contacts.clear(),
            db.vcards.clear(),
            db.tags.clear(),
            db.template_messages.clear(),
            db.locations.clear(),
            db.groups.clear(),
            db.group_messages.clear(),
        ]);

        clearUser();
    };

    const changeTheme = () => {
        settings.value.darkMode = !settings.value.darkMode;

        axios.post(
            `/operator/v4/user/settings`,
            {
                key: "theme",
                value: (settings.value.darkMode) ? "dark" : "light"
            }
        );
    }

    const sendHeartBeat = async (sessionId: string, shouldUpdate: boolean) => {
        axios.post('/operator/v4/heart-beat', {session: sessionId, shouldUpdate: shouldUpdate}
        ).then((r) => {
            const loginLog = r.data
            let now: number = new Date().getTime()
            let updatedAt: number = new Date(loginLog.updated_at).getTime();
            let diffInMinutes = (now - updatedAt) / 1000 / 60;
            if (diffInMinutes >= 55) {
                alert("Você será desconectado em 5 minutos por inatividade.");
            }
        }).catch(error => console.error(error.message()));
    }

    return {
        // status refs
        details,
        sendHeartBeat,
        status,
        getStatus,

        authError,
        setAuthError,
        clearAuthError,

        setStatus,
        setUser,
        clearUser,

        setLastSync,
        getLastSync,
        clearLastSync,

        goToLogin,
        ///resetSession,

        // data refs
        user,
        archivedConversations,
        settings,
        recentEmoji,
        emojiSkinTone,

        // ui refs
        activeSidebarComponent,
        delayLoading,
        conversationOpen,
        changeTheme,
    }
})

export default useStore